export default {
  beforeMount() {
    this.$cookies.delete('g_state');
  }
}